// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x1Z3fgfu_2yZX_ {
  display: inline-block;
  text-decoration: underline;
}
.x1Z3fgfu_2yZX_ p {
  color: var(--ds-link, #0c66e4);
  font-weight: var(--ds-font-weight-bold, 700);
}
`, ""]);
// Exports
export var currentCheckItem = `x1Z3fgfu_2yZX_`;
export default ___CSS_LOADER_EXPORT___;
